export const CALCULATE_ORDER_PAYMENT = "CALCULATE_ORDER_PAYMENT"
export const CALCULATE_ORDER_PAYMENT_SUCCESSFUL = "CALCULATE_ORDER_PAYMENT_SUCCESSFUL"
export const CALCULATE_ORDER_PAYMENT_FAILED = "CALCULATE_ORDER_PAYMENT_FAILED"
